export const Card = ({ children, className = "", ...p }) => (
  <div className={`card-glow-border rounded-2xl p-6 bg-[#0f1117] ${className}`} {...p}>{children}</div>
);

export const Stat = ({ label, value, sub }) => (
  <Card>
    <div className="font-tech text-[9px] tracking-[0.2em] uppercase text-slate-500 mb-2">{label}</div>
    <div className="font-display font-extrabold text-2xl sm:text-3xl text-white">{value}</div>
    {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
  </Card>
);

export const Btn = ({ children, className = "", ...p }) => (
  <button
    {...p}
    className={`font-tech text-[10px] tracking-[0.15em] uppercase px-4 py-2 rounded-full bg-[#f97316]/15 border border-[#f97316]/40 text-[#f97316] hover:bg-[#f97316] hover:text-black transition-colors disabled:opacity-50 ${className}`}
  >
    {children}
  </button>
);

export const Input = (p) => (
  <input
    {...p}
    className="w-full bg-white/5 border border-white/15 rounded-lg px-3 py-2.5 text-sm text-white focus:border-[#f97316] outline-none placeholder:text-slate-600"
  />
);

export const SectionTitle = ({ children }) => (
  <h3 className="font-display font-bold text-xl mb-5">{children}</h3>
);

export const Empty = ({ children }) => (
  <p className="text-slate-500 text-sm py-8 text-center">{children}</p>
);

export const Table = ({ cols, children }) => (
  <div className="overflow-x-auto">
    <table className="w-full text-sm">
      <thead>
        <tr>
          {cols.map((c) => (
            <th key={c} className="text-left font-tech text-[9px] tracking-[0.18em] uppercase text-slate-500 pb-3 pr-4 whitespace-nowrap">{c}</th>
          ))}
        </tr>
      </thead>
      <tbody className="divide-y divide-white/5">{children}</tbody>
    </table>
  </div>
);

export const Pill = ({ tone = "slate", children }) => {
  const tones = {
    orange: "text-[#f97316] border-[#f97316]/40 bg-[#f97316]/10",
    green: "text-emerald-400 border-emerald-400/40 bg-emerald-400/10",
    red: "text-red-400 border-red-400/40 bg-red-400/10",
    slate: "text-slate-400 border-white/15 bg-white/5",
    amber: "text-amber-400 border-amber-400/40 bg-amber-400/10",
  };
  return (
    <span className={`inline-block font-tech text-[9px] tracking-[0.12em] uppercase border rounded-full px-2.5 py-1 whitespace-nowrap ${tones[tone]}`}>
      {children}
    </span>
  );
};

export const money = (cents) => `CA$${((cents || 0) / 100).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
